exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-body>img[data-v-4257083a]{height:auto;max-width:100%;display:block}", ""]);

// exports
